import React from 'react';
import '../Auth/LoginModal.css';
import './LearnMoreModal.css';

type LearnMoreModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpenWaitlist?: () => void;
};

export const LearnMoreModal: React.FC<LearnMoreModalProps> = ({ isOpen, onClose, onOpenWaitlist }) => {
  if (!isOpen) return null;

  return (
    <div className="auth-modal__overlay" onClick={onClose}>
      <div className="auth-modal__dialog learn-more-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal__header">
          <h2 className="auth-modal__title">Private Circle</h2>
          <button type="button" className="auth-modal__close" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>
        <div className="auth-modal__body">
          <p className="learn-more-modal__lead">
            Мы запускаем закрытое сообщество для топ-менеджеров инвестиционных компаний
          </p>
          <p className="learn-more-modal__desc">
            Сообщество создано для конфиденциального обмена лучшими управленческими практиками, инсайтами по компенсациям и отраслевыми метриками — информации, недоступной в открытых источниках.
          </p>
          <ul className="learn-more-modal__list">
            <li className="learn-more-modal__item">
              <span className="learn-more-modal__icon">✦</span>
              <p>Получите доступ к эксклюзивным отраслевым инсайтам, которых нет в открытом доступе.</p>
            </li>
            <li className="learn-more-modal__item">
              <span className="learn-more-modal__icon">✦</span>
              <p>Обменивайтесь лучшими управленческими практиками и подходами к компенсациям на peer-level.</p>
            </li>
            <li className="learn-more-modal__item">
              <span className="learn-more-modal__icon">✦</span>
              <p>Конфиденциальность гарантирована: все участники проходят строгий отбор, а общение строго закрытое.</p>
            </li>
          </ul>
          <p className="learn-more-modal__cta">
            Сейчас открыта регистрация в waitlist — оставьте заявку и станьте одним из первых членов закрытого сообщества Private Circle.
          </p>
          {onOpenWaitlist && (
            <button
              type="button"
              className="learn-more-modal__apply-btn"
              onClick={() => { onClose(); onOpenWaitlist(); }}
            >
              Оставить заявку
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
